<template>
  <template v-if="isLoaded">
    <div class="menu-view">
      <div class="farm-window text-window">
        <div class="stat-row" style="grid-template-columns: 50px 1fr 50px;">
          <p></p>
          <h1 style="text-align: center; margin: 0;">Cowgirl Dairy Farm</h1>
          <p style="text-align: right; margin: 0; line-height: 20px;">v{{saveSystem.gameVersion}}</p>
        </div>
        <div class="farm-window start-menu-text">
          <p>Welcome!</p>
          <p>You're about to run your very own dairy farm. Be prepared that this will involve <b>sexual content</b> like <b>bimbofication</b>, <b>breast expansion</b>, <b>mental transformations</b> and additional transformations like growing horns, a tail, etc. If you are not comfortable with, or legally allowed to view such content, turn around now. </p>
          <p>Otherwise, if you have feedback or questions, let me know in the comments!</p>
        </div>

        <div class="start-menu-buttons">
          <TextButton class="farm-button" @click="$emit('goto-view', 'Milkfarm')">
            <h3>Start</h3>
          </TextButton>
          <TextButton class="farm-button" @click="$emit('goto-view', 'PatchNotesScreen')">
            <h3>Patch Notes</h3>
          </TextButton>
          <TextButton class="farm-button" @click="$emit('goto-view', 'HelpMenu')">
            <h3>Help</h3>
          </TextButton>
          <TextButton class="farm-button" @click="$emit('goto-view', 'CreditsScreen')">
            <h3>Credits</h3>
          </TextButton>
        </div>
        <div class="start-menu-buttons" style="margin-top: 50px;">
          <TextButton class="farm-button" @click="window().location.href = 'https://www.blushingdefeat.com/play/'">
            <h3>Exit to Blushing Defeat</h3>
          </TextButton>
        </div>
      </div>

      <PatreonButton></PatreonButton>

    </div>
  </template>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component'
import Farm from '@/farm/Farm'
import util from '../../util'
import TextButton from '@/components/ui/TextButton.vue'
import SavesCard from '@/components/SavesCard.vue'
import SaveSystem from '@/SaveSystem'
import PatreonButton from '@/components/ui/PatreonButton.vue'
import { Personality } from "@/employee/Personality"
import { allPersonalities } from "@/employee/Personalities"
import HelpMenu from "@/components/screens/HelpMenu.vue"
import PatchNotesScreen from "@/components/screens/PatchNotesScreen.vue"
import CreditsScreen from "@/components/screens/CreditsScreen.vue"

@Options({
  components: {
    TextButton, PatreonButton, HelpMenu, PatchNotesScreen, CreditsScreen
  },
  props: {
    saveSystem: Object
  },
  emits: ['goto-view', 'close'],
  methods: {
    log(msg: any) {
      console.log(msg)
    },
    util() {
      return util
    },
    window() {
      return window
    },
    allPersonalities(): Personality[] {
      return Object.entries(allPersonalities()).map(value => value[1])
    }
  },
  async created() {
    //let farm = new Farm()
    //await farm.load()
    //this.farm = farm
    this.isLoaded = true
  }
})
export default class StartMenu extends Vue {
  isLoaded = false
  saveSystem!: SaveSystem
}
</script>

<style scoped lang="scss">

.menu-view {
  //max-width: $full-page-width;

  display: grid;
  grid-template-rows: auto auto;
  grid-template-columns: 1fr;
  grid-template-areas:
    "t"
    "p";
  grid-gap: 20px;
  margin: 20px;

  @media screen and (max-width: $mobile-width){
    grid-template-areas:
      "t"
      "p";
    margin: 0;
  }
}

.text-window {
  grid-area: t;

  display: flex;
  flex-direction: column;
  min-height: 200px;
  max-width: 600px;
  margin: auto;

  padding: 30px;
  box-sizing: border-box;

  p {
    margin-top: 1em;
    margin-bottom: 1em;
  }

  @media screen and (max-width: $mobile-width){
    padding: 10px
  }
}

.patreon-button {
  grid-area: p;

  box-sizing: border-box;
  margin: auto;
  width: 100%;
  max-width: 600px;
  max-height: 150px;
}

.start-menu-text {
  background: $component-background-color;
  margin: 10px auto 50px auto;
  width: 100%;
  box-sizing: border-box;
}

.start-menu-buttons {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  align-items: center;

  .text-button {
    width: 100%;
    box-sizing: border-box;
    padding: 15px;
    margin: 5px 0;
  }
}

.blushing-defeat-button-row {
  grid-template-columns: 1fr !important;
  height: 50px;
  margin-top: auto;
}

#credits-window {
  grid-area: c;
}

#help-window {
  grid-area: h;

  h3 {
    margin-top: 10px;
  }
}

.saves-window {
  grid-area: s;

  input {
    background-color: $component-background-color;
    color: white;
    border: 1px solid black;
    border-right: 0;
    text-align: center;
    font-size: 16px;
  }

  .selected-save {
    display: grid;
    grid-template-rows: 1fr;
    background-color: $component-background-color;
    height: 100px;
  }
}

.stat-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-auto-rows: minmax(40px, 1fr);
}

.text-button {
  border: $component-border-style;

  display: table;
  div {
    display: table-cell;
    vertical-align: middle;
  }

  & > h3 {
    display: table-cell;
    vertical-align: middle;
    text-align: center;
  }
}

.help-list {
  max-height: 500px;
  overflow-y: auto;

  .farm-window {
    display: flex;
    flex-direction: column;
    margin-bottom: 10px;

    div {
      display: grid;
      grid-template-columns: 11ch 1fr;
      padding-top: 5px;
      padding-bottom: 5px;
      border-top: 1px solid white;
    }
  }

  p {
    margin: 0;
  }
}

.credits-block {
  &:first-child {
    h3 {
      margin-top: 0;
    }
  }

  h3 {
    margin-bottom: 5px;
    margin-top: 15px;
  }

  p {
    margin: 0;
  }
}
</style>
